import React from 'react';
import ArtOfPossibleTab from '../components/artofpossible/ArtOfPossibleTab';

interface ArtOfPossibleProps {
  onShowHelp?: () => void;
}

export const ArtOfPossible: React.FC<ArtOfPossibleProps> = ({ onShowHelp }) => {
  return <ArtOfPossibleTab onShowHelp={onShowHelp} />;
};

export default ArtOfPossible;
